var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99858 3.33333C11.7486 3.33333 13.4152 4 14.6652 5.25C17.2486 7.83333 17.2486 12.0833 14.6652 14.6667C13.1652 16.25 11.0819 16.8333 9.08191 16.5833L9.49858 14.9167C10.9152 15.0833 12.4152 14.5833 13.4986 13.5C15.4152 11.5833 15.4152 8.41667 13.4986 6.41667C12.5819 5.5 11.2486 5 9.99858 5V8.83333L5.83191 4.66667L9.99858 0.5V3.33333ZM5.24858 14.6667C3.08191 12.5 2.74858 9.16667 4.24858 6.58333L5.49858 7.83333C4.58191 9.66667 4.91525 12 6.49858 13.5C6.91525 13.9167 7.41525 14.25 7.99858 14.5L7.49858 16.1667C6.66525 15.8333 5.91525 15.3333 5.24858 14.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.2bb60e7037243f088876ecac8df6d5af.svg";
export { ForwardRef as ReactComponent };